module.exports = __webpack_public_path__ + "static/media/avatar-25.14f57bc5.svg";